import React, {useEffect, useRef} from 'react';
import {
  AccessibilityInfo,
  findNodeHandle,
  TouchableOpacity,
  useWindowDimensions,
  View,
  ViewStyle,
} from 'react-native';

import Avatar from './Avatar';
import FullName from './FullName';
import RankName from './RankName';
import RankProgress from './RankProgress';
import {styles} from './UserInfo.style';

interface UserInfoProps {
  style: {
    base?: ViewStyle;
  };
}

export const UserInfo: React.FC<UserInfoProps> = ({style: styleProp = {}}) => {
  const avatarRef = useRef(null);
  const {width, height} = useWindowDimensions();
  const isLandscape = width > height;

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (avatarRef.current) {
        const reactTag = findNodeHandle(avatarRef.current);
        if (reactTag) {
          AccessibilityInfo.setAccessibilityFocus(reactTag);
        }
      }
    }, 500);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <View
      style={[
        styles.base,
        isLandscape && styles.baseLandscape,
        styleProp.base,
      ]}>
      <View
        style={[styles.avatarRow, isLandscape && styles.avatarRowLandscape]}>
        <TouchableOpacity
          ref={avatarRef}
          accessible
          accessibilityLabel="Login Coach profile picture"
          onPress={() => {}}>
          <Avatar />
        </TouchableOpacity>
      </View>

      <View style={isLandscape && styles.landscapeTextContainer}>
        <RankName />
        <FullName />
        <RankProgress />
      </View>
    </View>
  );
};

export default UserInfo;
